<template>
  <validation-observer ref="updatePartnerConfig" #default="{ invalid }">
    <n-form-confirmation
      key="updatePartnerConfig"
      :form="$refs.updatePartnerConfig"
      :disabled="invalid"
      @submit="validateForm"
    >
      <n-input v-model="config" :fields="fields" />
      <b-row>
        <b-col cols="12" class="text-right">
          <n-button-loading
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            type="submit"
            variant="primary"
            class="mt-1"
            :loading="loading"
            :disabled="invalid || disabled"
          >
            {{ $t("button.saveChanges") }}
          </n-button-loading>
        </b-col>
      </b-row>
    </n-form-confirmation>
  </validation-observer>
</template>

<script>
import {
  BCard,
  BCardTitle,
  BCardText,
  BLink,
  BRow,
  BCol,
  BButton,
  BAvatar,
  BAlert,
  BFormGroup,
  BFormRating,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import NButtonLoading from "@/components/NButtonLoading";
import NFormConfirmation from "@/components/NFormConfirmation";
import NInput from "@/components/NInput";
import { mapValidationMessage } from "@/libs/helper";
import NSingleImageUploader from "@/components/NSingleImageUploader";
import Repository from "@/repositories/RepositoryFactory";
import FormInput from "./updatePartnerConfig";

const IntegrationRepository = Repository.get("integration");

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardTitle,
    BCardText,
    BLink,
    BButton,
    BAvatar,
    BAlert,
    BFormGroup,
    NButtonLoading,
    NFormConfirmation,
    NInput,
    NSingleImageUploader,
    BFormRating,
  },
  directives: {
    Ripple,
  },
  props: {
    data: {
      type: Object,
      default() {
        return {};
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      config: this.data,
      loading: false,
    };
  },
  computed: {
    fields() {
      if (this.disabled) {
        return FormInput.map((item) => ({
          ...item,
          disabled: true,
        }));
      }
      return FormInput;
    },
  },
  methods: {
    validateForm() {
      this.$refs.updatePartnerConfig.validate().then((success) => {
        if (success) {
          this.submit();
        }
      });
    },
    submit() {
      this.loading = true;
      IntegrationRepository.updateChatMe({
        ...this.config,
        mode: window.VUE_APP_CHAT_ME_MODE,
      })
        .catch((error) => {
          if (error.response?.status === 422) {
            const errorMessage = mapValidationMessage(
              error.response.data.validate
            );
            this.$refs.updatePartnerConfig.setErrors(errorMessage);
          }
        })
        .then(() => {
          this.loading = false;
        });
    },
  },
  // setup() {
  //   const fields = FormInput;
  //   return {
  //     fields,
  //   };
  // },
};
</script>
